import React from 'react';
import styled from 'styled-components';
import { Colors } from '../../ui';
import { Logo } from '../canvas/ui/Logo';
import { Copy, Flexer } from '../dashboard/elements/LayoutElements';

const BubbleStart = () =>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 40">
        <path fill="#e1e4eb" d="M24,38.5h-5.73c-4.69,0-8.5-3.81-8.5-8.5v-4.45l-.78-.43-6.62-3.64c-.55-.3-.88-.86-.88-1.48s.33-1.18.88-1.48l6.62-3.64.78-.43v-4.45c0-4.69,3.81-8.5,8.5-8.5h5.73V0h-5.73c-5.52,0-10,4.48-10,10v3.56l-6.62,3.64c-2.21,1.21-2.21,4.38,0,5.6l6.62,3.64v3.56c0,5.52,4.48,10,10,10h5.73v-1.5Z" />
    </svg>;

const BubbleMiddle = ({ children }) =>
    <Flexer relative flex center height="2.5rem">
        <svg style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 40" preserveAspectRatio="none">
            <pattern id="bubbleMiddlePattern" width="8" height="40" patternUnits="userSpaceOnUse">
                <path fill="#e1e4eb" d="M0,40h8v-1.5H0v1.5ZM0,1.5h8V0H0v1.5Z" />
            </pattern>
            <rect x="0" y="0" width="100%" height="100%" fill="url(#bubbleMiddlePattern)" />
        </svg>
        {children}
    </Flexer>;


const BubbleEnd = () =>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 40">
        <path fill="#e1e4eb" d="M14,1.5c4.69,0,8.5,3.81,8.5,8.5v20c0,4.69-3.81,8.5-8.5,8.5H0v1.5h14c5.52,0,10-4.48,10-10V10C24,4.48,19.52,0,14,0H0v1.5h14" />
    </svg>;

// Keep the URL versions for backward compatibility
const bubbleSvgUrl = 'data:image/svg+xml,%3Csvg width=\'48\' height=\'40\' viewBox=\'0 0 48 40\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M19.3242 2.5C14.2156 2.5 10.0742 6.64137 10.0742 11.75V15.985L3.23037 19.1131C2.25654 19.5582 2.25654 20.9418 3.23037 21.3869L10.0742 24.515V27.75C10.0742 32.8586 14.2156 37 19.3242 37H35.75C40.8586 37 45 32.8586 45 27.75V11.75C45 6.64137 40.8586 2.5 35.75 2.5H19.3242ZM8.57422 11.75C8.57422 5.81294 13.3872 1 19.3242 1H35.75C41.6871 1 46.5 5.81294 46.5 11.75V27.75C46.5 33.6871 41.6871 38.5 35.75 38.5H19.3242C13.3872 38.5 8.57422 33.6871 8.57422 27.75V25.4786L2.60682 22.7511C0.4644 21.7719 0.464391 18.7281 2.60681 17.7489L8.57422 15.0214V11.75Z\' fill=\'%23E1E4EB\'/%3E%3C/svg%3E';
const middleSvgUrl = 'data:image/svg+xml,%3Csvg width=\'10\' height=\'40\' viewBox=\'0 0 10 40\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Crect y=\'1\' width=\'10\' height=\'1.5\' fill=\'%23E1E4EB\'/%3E%3Crect y=\'37\' width=\'10\' height=\'1.5\' fill=\'%23E1E4EB\'/%3E%3C/svg%3E';

// The left part (tail) of the speech bubble
// const BubbleLeft = styled.div`
//     width: 1.25rem;
//     height: 2.5rem;
//     background-image: url("${bubbleSvgUrl}");
//     background-repeat: no-repeat;
//     background-position: left center;
// `;

// const BubbleMiddle = styled.div`
//     display: flex;
//     align-items: center;
//     justify-content: flex-start;
//     height: 2.5rem;
//     padding: 0 .625rem;
//     background-image: url("${middleSvgUrl}");
//     background-repeat: repeat-x;
//     background-position: center center;
// `;

// const BubbleRight = styled.div`
//     width: 1.25rem;
//     height: 2.5rem;
//     background-image: url("${bubbleSvgUrl}");
//     background-repeat: no-repeat;
//     background-position: right center;
// `;

// The container that holds all three sections
const BubbleFrame = styled.div`
  display: flex;
  width: fit-content;

  svg {
    height: 2.5rem;
  }
`;

const SpeechBubble = ({ children }) => {
    return (
        <BubbleFrame>
            <BubbleStart />
            <BubbleMiddle>
                <Copy flush color={Colors.textLighter} bold>{children}</Copy>
            </BubbleMiddle>
            <BubbleEnd />
        </BubbleFrame >
    );
};

export const TeaserHeader = () => {
    return <Flexer flex="row" align="center" padding="0 2" color={Colors.textLight}>
        <Logo size="2.5" />
        <SpeechBubble>
            <span>So, what are we gonna make today?</span>
        </SpeechBubble>
    </Flexer>;
};
